/* globals lp */
var InvariantsHelper = require('./invariants-helper');
var jQuery = require('jquery');
var _ = require('lodash');

(function() {
  var register = lp.invariants.register,
    helper = InvariantsHelper;

  var _isVisibilityOnCanvasAndContentTreeEqual = function(elm) {
    var $menu = jQuery('#menu-item-' + elm.id);
    var $menuVisibilityIcon = $menu.find('.visibility-state').first(),
      isMenuItemVisible = !$menuVisibilityIcon.hasClass('lp-hidden') &&
      $menuVisibilityIcon.parents('.lp-hidden').length === 0;

    return isMenuItemVisible === elm.isVisibleOnPage() &&
      _.every(
        elm.getChildElements(),
        function(childElm) {
          return _isVisibilityOnCanvasAndContentTreeEqual(childElm);
        }
      );
  };

  register(
    'editor.activeElement is in sync with page-element-tree',
    function(editor, assert) {
      if ( ! editor.treeToggler.isOpen()) {
        return true;
      }
      var activeEl = editor.activeElement;
      var $activeMenuItem = jQuery('.page-element-tree').find('.active');
      if (activeEl === null || activeEl.id === 'lp-pom-root' || activeEl.id.indexOf('lp-multi-select') > -1) {
        return assert($activeMenuItem.length === 0);
      } else {
        return assert($activeMenuItem.attr('id') === ('menu-item-' + activeEl.id));
      }
    }
  );

  register(
    'ContentTreeMatchesPOM',
    function(_editor, assert) {
      return _.every(
          helper.getPOMElementsByName("block"),
          function(elm) {
            var result = _isVisibilityOnCanvasAndContentTreeEqual(elm);
            return assert(result, "Content tree state does not match the POM for #" + elm.id);
          }
        );
    }
  );
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/invariants/content-tree-invariants.js
// module id = 1070
// module chunks = 0